import { Controller } from "@hotwired/stimulus"
import { Device } from "@twilio/voice-sdk"
import { PowerDialerBridge } from "../lib/powerDialerBridge"

export default class extends Controller {
  static targets = ["callButton", "skipButton", "outcomeButtons", "callStatus"]
  static values = {
    sessionId: Number,
    tokenUrl: String,
  }

  connect() {
    this.setupKeyboardShortcuts()
    this.bridge = new PowerDialerBridge({
      DeviceClass: Device,
      tokenUrl: this.tokenUrlValue,
      csrfToken: document.querySelector("[name='csrf-token']")?.content,
      onStatus: (message, tone) => this.showStatus(message, tone),
    })
  }

  disconnect() {
    this.removeKeyboardShortcuts()
    this.bridge?.destroy()
  }

  setupKeyboardShortcuts() {
    this.boundHandleKeyPress = this.handleKeyPress.bind(this)
    document.addEventListener("keydown", this.boundHandleKeyPress)
  }

  removeKeyboardShortcuts() {
    if (this.boundHandleKeyPress) {
      document.removeEventListener("keydown", this.boundHandleKeyPress)
    }
  }

  handleKeyPress(event) {
    // Ignore if user is typing in an input field
    if (event.target.tagName === "INPUT" || event.target.tagName === "TEXTAREA") {
      return
    }

    switch(event.key.toLowerCase()) {
      case "c":
        event.preventDefault()
        this.call()
        break
      case "s":
        event.preventDefault()
        this.skip()
        break
      case "1":
        event.preventDefault()
        this.markOutcome("connected")
        break
      case "2":
        event.preventDefault()
        this.markOutcome("no_answer")
        break
      case "3":
        event.preventDefault()
        this.markOutcome("busy")
        break
    }
  }

  async call(event) {
    if (event) event.preventDefault()
    if (this.callPending || !this.hasCallButtonTarget) return

    const form = event?.currentTarget?.form || this.callButtonTarget.form
    if (!form) {
      this.showStatus("Could not find the Power Dialer call form", "error")
      return
    }

    this.callPending = true
    this.callButtonTarget.disabled = true
    try {
      await this.bridge.startCall({
        url: form.action,
        body: new FormData(form),
      })
      if (this.hasOutcomeButtonsTarget) {
        this.outcomeButtonsTarget.style.display = "block"
      }
    } catch (error) {
      this.callButtonTarget.disabled = false
    } finally {
      this.callPending = false
    }
  }

  skip(event) {
    if (event) return
    if (this.hasSkipButtonTarget) {
      this.skipButtonTarget.form?.requestSubmit(this.skipButtonTarget)
    }
  }

  markOutcome(outcome) {
    // Find the button for this outcome and click it
    const button = this.element.querySelector(`button[formaction*="outcome=${outcome}"]`)
    if (button) {
      button.click()
    }
  }

  showStatus(message, tone = "neutral") {
    if (!this.hasCallStatusTarget) return
    this.callStatusTarget.textContent = message
    this.callStatusTarget.dataset.tone = tone
  }
}
